import { DriverCache } from '@stores/acceptedOrders/types';
import { logger } from '@lib/logger';
import { OrderSummary, TripDriver } from '@lib/types';

import { client } from './client';
import { endpoints } from './endpoints';

type OrderIds = {
  ordersUUIDs: string[];
};

export async function fetchDriverInfo(data: OrderIds): Promise<TripDriver[]> {
  const response = await client.post(endpoints.DRIVER_INFO, data);

  return response.data;
}

export async function fetchOrdersDriversInfo(
  orders: OrderSummary[],
): Promise<DriverCache[]> {
  const uuids = orders.map((order: OrderSummary) => order.uuid);
  if (!uuids.length) {
    return [];
  }
  try {
    const response = await fetchDriverInfo({
      ordersUUIDs: uuids,
    });
    const arr: any = response.filter((item) => item.tripDriverCache);
    return arr;
  } catch (error) {
    logger.error('Failure!', error);
    return [];
  }
}
